import { ASSET_ICON } from '../constants'
import type { BrandInfo } from '../types'
import { logoPlateClass, onImgError } from '../utils'

interface JobBrandProps {
  brand: BrandInfo
}

export function JobBrand({ brand }: JobBrandProps) {
  const plate = logoPlateClass(brand.slug)
  return (
    <div className="cr-job-brand" style={{ ['--emp-cor' as string]: brand.cor_primaria }}>
      <span className={`cr-job-logo ${plate}`} aria-hidden="true">
        <img
          src={brand.logo_url}
          alt=""
          width={28}
          height={28}
          loading="lazy"
          onError={onImgError(ASSET_ICON)}
        />
      </span>
      <span className="cr-job-emp-chip">{brand.nome}</span>
    </div>
  )
}
